module.exports = __webpack_public_path__ + "static/dashboard_intro_api-691e8db6c7cacf41c71c1a8d21cd60be.png";